<template>
  <div class="login-card__login-card">
    <div class="login-card__title-box">
      <h5 class="login-card__title">{{ trans.get('auth.card.login.header') }}</h5>
      <p class="login-card__title-desc"> {{ trans.get('auth.card.login.subheader') }}</p>
    </div>
    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <div>

        <ValidationProvider name="response_error" v-slot="{ errors }" mode="eager">
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>
        <ValidationProvider name="email" v-slot="{ errors }" mode="eager">
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>
        <ValidationProvider name="phone" v-slot="{ errors }" mode="eager">
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>

      </div>
      <form @submit.prevent="handleSubmit(onSubmit)">
        <div class="form-group">
          <ValidationProvider name="login" rules="required" v-slot="{ errors }" mode="eager">
            <label for="login"></label>
            <input
              type="text"
              id="login"
              class="input-text input-text__underline"
              v-model="loginForm.login"
              :placeholder="loginPlaceholder"
            >
            <span class="text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <div class="form-group">
          <ValidationProvider name="password" rules="required" v-slot="{ errors }" mode="eager">
            <div class="input-group is-invalid">
              <label for="password"></label>
              <input
                :type="passwordInputType"
                id="password"
                class="form-control input-text input-text__underline"
                v-model="loginForm.password"
                :placeholder="trans.get('auth.card.fields.password')"
              >
              <div class="input-group-append">
                <button type="button" class="button__password-eye" @click="switchPasswordVisibility"><i class="fa fa-eye" aria-hidden="true"></i></button>
              </div>
            </div>
            <span class="text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <div class="checkbox-standard text-left mb-4">
          <label>
            <input type="checkbox" id="checkbox" v-model="loginForm.remember">
            <span class="checkbox-standard__box checkbox-standard__box--small checkbox-standard__box--purple mr-2"></span>
            <span class="desc desc--lightgrey desc-- pb-1"> {{ trans.get('auth.card.login.stay_logged_in') }}</span>
          </label>
        </div>
        <button type="submit" class="button button__fill btn-block ">{{ trans.get('auth.card.buttons.login') }}</button>
      </form>
    </ValidationObserver>
    <button type="button" class="button button__link button__link--underline" @click="swapComponent('auth-reset-password-card')">{{ trans.get('auth.card.login.forgot_password') }}</button>
    <a :href="zRoute('login.provider', 'facebook')" class="button button__link button__link--blue p-1"><i class="demo-icon icon-facebook pr-2"></i>{{ trans.get('auth.card.login.facebook') }}</a>
    <a :href="zRoute('login.provider', 'google')" class="button button__link button__link--google p-1"><img class="logo-google" src="/img/viluu/logo/google-logo.svg" alt="Logo google">{{ trans.get('auth.card.welcome.google_button') }}</a>
    <a :href="zRoute('login.provider', 'apple')" class="button button__link button__link--apple p-1"><img class="logo-apple" src="/img/viluu/logo/apple-logo.svg" alt="Logo google">{{ trans.get('auth.card.welcome.apple_button') }}</a>
    <button type="button" class="button button__link button__link--underline p-1" @click="swapComponent('auth-welcome-card')">{{ trans.get('auth.card.buttons.back') }}</button>
  </div>
</template>
<script>

import { ValidationObserver, ValidationProvider } from 'vee-validate';

export default {
  components: { ValidationObserver, ValidationProvider },
  props: ['swapComponent', 'form'],
  data: () => ({
    loginForm: {
      login: '',
      email: '',
      password: '',
      remember: false,
    },
    passwordInputType: 'password',
  }),
  computed: {
    loginPlaceholder: function () {
      // return this.globals.profile_phone.register ? trans.get('auth.card.fields.phone_email_login'):trans.get('auth.card.fields.login');
      return this.globals.profile.enable_name_login ? this.trans.get('auth.card.fields.name_email_login') : this.trans.get('auth.card.fields.login');
    }
  },
  methods: {
    switchPasswordVisibility() {
      this.passwordInputType = this.passwordInputType === 'password' ? 'text' : 'password';
    },
    onSubmit() {
      const self = this;

      axios
        .post(zRoute('login'), this.loginForm)
        .then((response) => {
          if (response.data.status === 'success') {
            window.location.href = zRoute('home');
          }
        })
        .catch((error) => {
          const data = error.response.data;

          if (error.response.status === 422) {
            self.$refs.form.setErrors(data.errors);
          } else {
            self.$refs.form.setErrors({ response_error: [self.trans.get('auth.error')] });
          }

          if (data.reason && data.reason.type && data.reason.message) {
            self.$notify({
              group: 'custom-template',
              type: 'error',
              text: data.reason.message,
              duration: 15000,
              data: {},
            });

            if (data.reason.type === 'USER_SELF_DELETE') {
              this.form.email = `${this.loginForm.login}`;
              this.swapComponent('auth-reset-password-card');
            }
          }
        });
    },
    async refreshCSRFToken() {
      axios
        .get(zRoute('ajax.csrf_token'))
        .then(response => {
          const token = response.data.csrfToken;
          document.querySelector('meta[name=csrf-token]').setAttribute('content', token);
          window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
        });
    },
    isEmail(login) {
      let re = /\S+@\S+\.\S+/;
      return re.test(login);
    }
  },
  activated() {
    this.refreshCSRFToken();
  },
};
</script>
<style scoped>
</style>
